import { render } from "./spinner.vue?vue&type=template&id=3ebb52d6&scoped=true&ts=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"

import "./spinner.vue?vue&type=style&index=0&id=3ebb52d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebb52d6"]])

export default __exports__